import { captureAppError } from "../sentry";

async function isStoragePersisted() {
  return (await navigator.storage) && navigator.storage.persisted
    ? navigator.storage.persisted()
    : undefined;
}

async function persist() {
  return (await navigator.storage) && navigator.storage.persist
    ? navigator.storage.persist()
    : undefined;
}

async function showEstimatedQuota() {
  return (await navigator.storage) && navigator.storage.estimate
    ? navigator.storage.estimate()
    : undefined;
}

async function tryPersistWithoutPromptingUser() {
  if (!navigator.storage || !navigator.storage.persisted) {
    return "never";
  }
  let persisted = await navigator.storage.persisted();
  if (persisted) {
    return "persisted";
  }
  if (!navigator.permissions || !navigator.permissions.query) {
    return "prompt"; // It MAY be successful to prompt. Don't know.
  }
  const permission = await navigator.permissions.query({
    name: "persistent-storage",
  });
  if (permission.state === "granted") {
    persisted = await navigator.storage.persist();
    if (persisted) {
      return "persisted";
    } else {
      throw new Error("Failed to persist");
    }
  }
  if (permission.state === "prompt") {
    return "prompt";
  }
  return "never";
}

async function promptUserForStoragePermission() {
  const permission = await navigator.permissions.query({
    name: "persistent-storage",
  });

  if (permission.state === "prompt") {
    try {
      const result = await navigator.storage.persist();
      if (result) {
        console.log("Storage permission granted after user prompt");
      } else {
        console.log("Storage permission denied after user prompt.");
      }
    } catch (error) {
      captureAppError(error, {
        tags: { source: "promptUserForStoragePermission" },
      });
      console.error(
        "Error when trying to persist storage after user prompt: ",
        error
      );
    }
  }
}

export { tryPersistWithoutPromptingUser, promptUserForStoragePermission };
